<template>
    <v-card>
        <v-toolbar color="blue-grey" dark>
            <v-toolbar-title>対象年月:{{ year_month }}</v-toolbar-title>
        </v-toolbar>
        <v-list>
            <v-list-group
                    :key="item.title"
                    no-action
                    v-for="item in items"
                    v-model="item.active"
            >
                <template v-slot:activator>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                {{ item.title }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                {{ item.amount }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>

                <v-list-tile
                        :key="subItem.title"
                        @click=""
                        v-for="subItem in item.items"
                >
                    <v-list-tile-content>
                        <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-content>
                        <v-list-tile-title class="text-right">{{ subItem.amount }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list-group>
            <v-list-tile>
                <v-list-tile-content>
                    <v-list-tile-title>
                        {{ total.title }}
                    </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-content>
                    <v-list-tile-title class="text-right">
                        {{ total.amount }}
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
    </v-card>
</template>

<script>
    export default {
        name: "SpPaymentBaseComponent",
        props: {
            year_month: String,
            payment_type: String,

            total_amount: Number,
            basic_amount: Number,
            additional_amount: Number,
            transportation_amount: Number,

            total_deduction_amount: Number,
            health_insurance_amount: Number,
            welfare_pension_amount: Number,
            employment_insurance_amount: Number,
            resident_tax: Number,
            year_end_adjustment_amount: Number,
            withholding_tax: Number,

            prepayment_amount: Number,
            advance_adjust_amount: Number,

            amount_of_deduction: Number,
        },
        data() {
            return {
                headers: {
                    payment: {
                        total_amount: appUtil.getLang('validation.attributes.payment.total_amount'),
                        basic_amount: '工事代金計',
                        transportation_amount: '交通費計',
                        additional_amount: '追加工事代金計',

                        total_deduction_amount: appUtil.getLang('validation.attributes.payment.total_deduction_amount'),
                        health_insurance_amount: appUtil.getLang('validation.attributes.payment.health_insurance_amount'),
                        welfare_pension_amount: appUtil.getLang('validation.attributes.payment.welfare_pension_amount'),
                        employment_insurance_amount: appUtil.getLang('validation.attributes.payment.employment_insurance_amount'),
                        resident_tax: appUtil.getLang('validation.attributes.payment.resident_tax'),
                        year_end_adjustment_amount: appUtil.getLang('validation.attributes.payment.year_end_adjustment_amount'),
                        withholding_tax: appUtil.getLang('validation.attributes.payment.withholding_tax'),

                        prepayment_amount: appUtil.getLang('validation.attributes.payment.prepayment_amount'),
                        advance_adjust_amount: appUtil.getLang('validation.attributes.payment.prepayment_amount'),

                        amount_of_deduction: appUtil.getLang('validation.attributes.payment.amount_of_deduction'),
                    }
                },
                items: null,
                total: null
            }
        },
        created() {
            this.items = [
                {
                    title: this.headers.payment.total_amount,
                    amount: appUtil.number_format(this.total_amount),
                    active: false,
                    items: [
                        {
                            title: this.headers.payment.basic_amount,
                            amount: appUtil.number_format(this.basic_amount),
                        },
                        {
                            title: this.headers.payment.transportation_amount,
                            amount: appUtil.number_format(this.transportation_amount),
                        },
                        {
                            title: this.headers.payment.additional_amount,
                            amount: appUtil.number_format(this.additional_amount),
                        },
                    ]
                },
                {
                    title: this.headers.payment.total_deduction_amount,
                    amount: appUtil.number_format(this.total_deduction_amount),
                    active: false,
                    items: this.getDeductionItems()
                },
                {
                    title: this.headers.payment.advance_adjust_amount,
                    amount: appUtil.number_format(this.advance_adjust_amount),
                    active: false,
                    items: [
                        {
                            title: this.headers.payment.prepayment_amount,
                            amount: appUtil.number_format(this.prepayment_amount),
                        },
                    ]
                },
            ];

            this.total = {
                title: this.headers.payment.amount_of_deduction,
                amount: appUtil.number_format(this.amount_of_deduction),
                active: false,
            };

        },
        methods: {
            getDeductionItems() {
                if (this.payment_type == '01') {
                    return [
                        {
                            title: this.headers.payment.health_insurance_amount,
                            amount: appUtil.number_format(this.health_insurance_amount),
                        },
                        {
                            title: this.headers.payment.welfare_pension_amount,
                            amount: appUtil.number_format(this.welfare_pension_amount),
                        },
                        {
                            title: this.headers.payment.employment_insurance_amount,
                            amount: appUtil.number_format(this.employment_insurance_amount),
                        },
                        {
                            title: this.headers.payment.resident_tax,
                            amount: appUtil.number_format(this.resident_tax),
                        },
                        {
                            title: this.headers.payment.year_end_adjustment_amount,
                            amount: appUtil.number_format(this.year_end_adjustment_amount),
                        },
                        {
                            title: this.headers.payment.withholding_tax,
                            amount: appUtil.number_format(this.withholding_tax),
                        },
                    ]
                } else {
                    return [
                        {
                            title: this.headers.payment.withholding_tax,
                            amount: appUtil.number_format(this.withholding_tax),
                        },
                    ]
                }
            }
        }
    }
</script>

<style scoped>

</style>